import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-description-producer-list',
  templateUrl: './description-producer-list.component.html',
  styleUrls: ['./description-producer-list.component.scss'],
})
export class DescriptionProducerListComponent {
  isEditMode: any;
  selectedPlantType: any;
  @Input() consumer: any;
  @Input() producers: any;
  @Output() assetSelectEmitter = new EventEmitter();

  public select(producer: any) {
    this.assetSelectEmitter.emit(producer);
  }

  trackByFn(_: number, item: any) {
    return item.guid;
  }
}
